import script from "./trainerBoxV2.vue?vue&type=script&setup=true&lang=js"
export * from "./trainerBoxV2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__